<template>
  <div class="popup-container">
    <transition-group name="popup-list" tag="div" class="popup-list">
      <StackedPopupNotification
        v-for="notification in stackedNotifications"
        :key="notification.id"
        :id="notification.id"
        :type="notification.type"
        :title="notification.title"
        :message="notification.message"
        :duration="notification.duration"
        :count="notification.count"
        @close="removeNotificationsByType"
      />
    </transition-group>
  </div>
</template>

<script>
import StackedPopupNotification from './StackedPopupNotification.vue'

export default {
  name: 'PopupContainer',
  components: {
    StackedPopupNotification,
  },
  data() {
    return {
      notifications: [],
    }
  },
  computed: {
    stackedNotifications() {
      // Group notifications by type only
      const grouped = {}

      this.notifications.forEach(notification => {
        const key = notification.title
        if (!grouped[key]) {
          grouped[key] = {
            ...notification,
            count: 1,
          }
        } else {
          grouped[key].count++
          // Update the id to the latest one
          grouped[key].id = notification.id
          // Update duration to the latest one
          grouped[key].duration = notification.duration
          // Update message to show count
          grouped[key].message = notification.message
        }
      })

      // Convert grouped object to array
      return Object.values(grouped)
    },
  },
  created() {
    // Listen for notification events
    this.$root.$on('add-notification', this.addNotification)
    this.$root.$on('remove-notification', this.removeNotification)
    this.$root.$on('clear-notifications', this.clearNotifications)
  },
  beforeDestroy() {
    // Clean up event listeners
    this.$root.$off('add-notification', this.addNotification)
    this.$root.$off('remove-notification', this.removeNotification)
    this.$root.$off('clear-notifications', this.clearNotifications)
  },
  methods: {
    addNotification(notification) {
      // Add a unique ID if not provided
      const notificationWithId = {
        id:
          notification.id ||
          `notification_${Date.now()}_${Math.floor(Math.random() * 10000)}`,
        type: notification.type || 'info',
        title: notification.title || '',
        message: notification.message || '',
        duration:
          notification.duration !== undefined ? notification.duration : 5000,
      }

      // Add to the beginning of the array so new notifications appear on top
      this.notifications.unshift(notificationWithId)

      // Limit to 10 notifications
      if (this.notifications.length > 10) {
        // Remove the oldest notification
        this.notifications.pop()
      }
    },
    removeNotification(id) {
      // Find and remove notification by ID
      const index = this.notifications.findIndex(
        notification => notification.id === id
      )
      if (index !== -1) {
        this.notifications.splice(index, 1)
      }
    },
    removeNotificationsByType(type) {
      // Remove all notifications of a specific type
      this.notifications = this.notifications.filter(
        notification => notification.type !== type
      )
    },
    clearNotifications() {
      this.notifications = []
    },
  },
}
</script>

<style scoped lang="scss">
.popup-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  width: 350px;
}

.popup-list {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

// Transitions for notifications
.popup-list-enter-active,
.popup-list-leave-active {
  transition: all 0.3s;
}

.popup-list-enter {
  opacity: 0;
  transform: translateX(100%);
}

.popup-list-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.popup-list-move {
  transition: transform 0.3s;
}
</style>
